import React from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  // InputAdornment,
  // TextField,
  Divider,
} from "@mui/material";

import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
import DeviceService from "src/service/device";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { Link } from "react-router-dom";

import {
  IconFileDownload,
  IconPlus,
  //  IconSearch
} from "@tabler/icons";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { writeFile } from "xlsx";
import moment from "moment";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Device",
  },
];

const Device = () => {
  const navigate = useNavigate();

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [device, setDevice] = useState([]);

  // const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [visibleData, setVisibleData] = useState([]);
  //  for table sorting
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState("device_name"); // Initial column to sort

  const fetchDeviceData = async () => {
    try {
      const res = await DeviceService.getDevice({
        manufacturer_id: sessionData.data.manufacturer_id,
      });

      let modifiedData = [];

      for (const ele of res.data) {
        if (modifiedData.some((val) => val.batch_no === ele.batch_no)) {
          const index = modifiedData.findIndex(
            (item) => item.batch_no === ele.batch_no
          );

          modifiedData[index].data.push(ele);
        } else {
          modifiedData.push({
            batch_no: ele.batch_no,
            data: [ele],
          });
        }
      }

      setDevice(modifiedData);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteDevice = async (id) => {
    swal({
      title: "Delete Device",
      text: "Are you sure you want to delete this device?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await DeviceService.deleteDevice({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetchDeviceData();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  useEffect(() => {
    fetchDeviceData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  // const filteredDevice = device.filter(
  //   (man) =>
  //     man.device_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     man.imei_no.includes(searchTerm)
  // );

  // useEffect(() => {
  //   const startIndex = page * rowsPerPage;
  //   const endIndex = startIndex + rowsPerPage;
  //   const filteredData = device.filter(
  //     (man) =>
  //       man.device_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       man.imei_no.includes(searchTerm)
  //   );
  //   const visibleData = filteredData.slice(startIndex, endIndex);
  //   setVisibleData(visibleData);
  // }, [device, page, rowsPerPage, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExport = () => {
    const headers = [
      "Sl. No",
      "Model Name",
      "Device Name",
      "Imei No",
      "Serial No",
      "Device Type",
      "Manufacturing Date",
      "Allotment status",
      "Allotment DateTime",
    ];

    const data = visibleData.map((man, index) => [
      index + 1,
      man.model_name,
      man.device_name,
      man.imei_no,
      man.serial_no,
      man.device_type === 1
        ? "GPS"
        : man.device_type === 2
        ? "SOS Button"
        : man.device_type === 3
        ? "GPS with SOS Button"
        : "",
      moment(man.manufacturing_date_time).format("DD-MM-YYYY H:mm:ss a"),
      man.issue_status === 1
        ? "Alloted"
        : man.issue_status === 0
        ? "Not Alloted"
        : "NA",
      man.issue_date_time !== null
        ? moment(man.issue_date_time).format("DD-MM-YYYY h:mm:ss a")
        : "NA",
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "device_data.xlsx";

    writeFile(wb, fileName);
  };

  // table column sorting start here
  const handleSort = (column) => {
    // Toggle sorting order if clicking on the same column
    if (sortColumn === column) {
      setSortOrder((prevSortOrder) =>
        prevSortOrder === "asc" ? "desc" : "asc"
      );
    } else {
      // Set new column to sort
      setSortColumn(column);
      // Default sorting order for the new column
      setSortOrder("asc");
    }
  };

  // const sortedDevice = filteredDevice.sort((a, b) => {
  //   const compareValueA = a[sortColumn];
  //   const compareValueB = b[sortColumn];

  //   // Customize the comparison based on data types or specific conditions
  //   if (sortOrder === "asc") {
  //     return compareValueA.localeCompare(compareValueB);
  //   } else {
  //     return compareValueB.localeCompare(compareValueA);
  //   }
  // });

  return (
    <PageContainer title="Device" description="this is Basic Table page">
      {/* breadcrumb */}
      <Breadcrumb title="Device" items={BCrumb} />
      {/* end breadcrumb */}

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Device List
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            {sessionData.data.user_type === 1 && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate("/adddevice");
                }}
              >
                <IconPlus width={20} />
              </Button>
            )}
            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            {/* <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder="search here"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            /> */}
          </Grid>
        </Grid>
        {/* </ParentCard> */}

        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={
                {
                  // whiteSpace: "nowrap",
                }
              }
            >
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      Sl. No
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("model_name")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      Model No
                      {sortColumn === "model_name" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("batch_no")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      Batch no
                      {sortColumn === "batch_no" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("manufacturing_date_time")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      Manufacturing Date
                      {sortColumn === "manufacturing_date_time" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("manufacturing_date_time")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      Make
                      {sortColumn === "manufacturing_date_time" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("device_name")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      Device Name
                      {sortColumn === "device_name" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("imei_no")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      IMEI No
                      {sortColumn === "imei_no" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("serial_no")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      Serial No
                      {sortColumn === "serial_no" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      Device Type
                    </Typography>
                  </TableCell>

                  {sessionData.data.user_type === 1 && (
                    <TableCell>
                      <Typography
                        style={{ fontSize: "15px", textAlign: "center" }}
                        variant="h6"
                      >
                        Action
                      </Typography>
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {device.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} style={{ textAlign: "center" }}>
                      <Typography
                        style={{ fontSize: "13px" }}
                        variant="h6"
                        sx={{ color: "red" }}
                      >
                        No records found!!
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  device.map((item, index) =>
                    item.data.map((man, ind) => (
                      <TableRow key={man.id}>
                        {ind === 0 && (
                          <TableCell
                            rowSpan={item.data.length}
                            style={{ borderRight: "1px solid #ddd" }}
                          >
                            <Typography
                              style={{ fontSize: "13px", textAlign: "center" }}
                              variant="h6"
                            >
                              {index + 1}
                            </Typography>
                          </TableCell>
                        )}
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {man.model_name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {man.batch_no}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {man.date_of_manufacturing !== null
                              ? moment(man.date_of_manufacturing).format(
                                  "DD-MM-YYYY"
                                )
                              : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {man.make !== null ? man.make : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {man.device_name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {man.imei_no}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {man.serial_no}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {man.device_type === 1
                              ? "GPS"
                              : man.device_type === 2
                              ? "SOS Button"
                              : man.device_type === 3
                              ? "GPS with SOS Button"
                              : ""}
                          </Typography>
                        </TableCell>

                        {sessionData.data.user_type === 1 && (
                          <TableCell style={{ textAlign: "center" }}>
                            <Link to={`/updatedevice/${man.id}`}>
                              <ModeEditOutlinedIcon
                                style={{
                                  color: "blue",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                              />
                            </Link>

                            <DeleteOutlinedIcon
                              style={{
                                color: "red",
                                fontSize: "18px",
                                marginLeft: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => deleteDevice(man.id)}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  )
                )}
              </TableBody>
              {/* ============================================================== */}
              {/* <TableBody>
                {device.map((man, index, array) => {
                  const areFirstFourFieldsSame =
                    index > 0 &&
                    man.model_name === array[index - 1].model_name &&
                    man.batch_no === array[index - 1].batch_no &&
                    man.date_of_manufacturing ===
                      array[index - 1].date_of_manufacturing &&
                    man.make === array[index - 1].make;
                  let serialNumber = 1;

                  if (areFirstFourFieldsSame) {
                    // Find the last index with the same combination of the first four fields
                    const lastIndex = array
                      .slice(0, index)
                      .findLastIndex(
                        (item) =>
                          item.model_name === man.model_name &&
                          item.batch_no === man.batch_no &&
                          item.date_of_manufacturing ===
                            man.date_of_manufacturing &&
                          item.make === man.make &&
                          item.serialNumber === 1
                      );

                    if (
                      lastIndex !== -1 &&
                      array[lastIndex].serialNumber !== "-"
                    ) {
                      // Use the serial number of the last occurrence and increment it
                      const lastSerialNumber = array[lastIndex].serialNumber;

                      alert("lastSerialNumber:", lastSerialNumber);

                      serialNumber = lastSerialNumber + 1;
                      alert("New serialNumber:", serialNumber);
                    }
                  }

                  return (
                    <TableRow key={man.id}>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {serialNumber}
                        </Typography>
                      </TableCell>
                      {[
                        "model_name",
                        "batch_no",
                        "date_of_manufacturing",
                        "make",
                      ].map((field, i) => (
                        <TableCell key={field}>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {areFirstFourFieldsSame && i < 5 ? "-" : man[field]}
                          </Typography>
                        </TableCell>
                      ))}
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {man.device_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {man.imei_no}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {man.serial_no}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {man.device_type === 1
                            ? "GPS"
                            : man.device_type === 2
                            ? "SOS Button"
                            : man.device_type === 3
                            ? "GPS with SOS Button"
                            : ""}
                        </Typography>
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <Link to={`/updatedevice/${man.id}`}>
                          <ModeEditOutlinedIcon
                            style={{
                              color: "blue",
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                          />
                        </Link>

                        <DeleteOutlinedIcon
                          style={{
                            color: "red",
                            fontSize: "18px",
                            marginLeft: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => deleteDevice(man.id)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody> */}

              {/* =============================================================== */}
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={device.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default Device;
